export default __webpack_public_path__ + "static/media/banners.3628ca20.svg";